import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import * as appointmentActions from 'yoda-site-components/lib/actions/AppointmentActions';
import * as sliderActions from 'yoda-site-components/lib/actions/AccountAction';
import Appointments from '../../../../components/Appointments/Appointments';

function mapStateToProps(state) {
    return {
        preferences: get(state, 'context.preferences.myAppointment', {}),
        messagesTexts: get(state, 'context.messagesTexts.myAppointment', {}),
        appointmentDetails: get(state, 'appointmentDetails'),
        userState: get(state.accounts, 'userProfile.userState', ''),
        locationServiceStoreInfo: get(state, 'locationServiceReducer', {}),
    };
}
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(appointmentActions, dispatch),
    sliderActions: bindActionCreators(sliderActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Appointments);
